<template>
    <button
        class="bookmark-button"
        :class="{ bookmarked: isBookmarked }"
        @click.prevent="toggleBookmark"
        type="button"
    >
        <font-awesome-icon :icon="isBookmarked ? ['fas', 'bookmark'] : ['far', 'bookmark']" />
    </button>
</template>

<script setup lang="ts">
import { useDeltaUserSettingsStore } from '@/stores/deltaGpt/deltaGptUserSettingsStore.ts';
import { computed } from 'vue';

const deltaGptUserSettingsStore = useDeltaUserSettingsStore();

const props = defineProps<{
    reportId: string;
}>();

async function toggleBookmark (event: MouseEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    if (isBookmarked.value) {
        await deltaGptUserSettingsStore.updateUserSettings({
            likedResearchIds: deltaGptUserSettingsStore.userSettings.likedResearchIds.filter(
                (id: string) => id !== props.reportId,
            ),
        });
    } else {
        await deltaGptUserSettingsStore.updateUserSettings({
            likedResearchIds: [
                ...deltaGptUserSettingsStore.userSettings.likedResearchIds,
                props.reportId,
            ],
        });
    }
}

const isBookmarked = computed(() => deltaGptUserSettingsStore.userSettings.likedResearchIds.includes(props.reportId));

</script>

<style lang="scss" scoped>
.bookmark-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.5rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--neutral400);
    transition: color 0.2s ease, transform 0.2s ease;
    margin-left: var(--smallSpacing);

    &:hover:not(.bookmarked) {
        color: var(--neutral900);
        transform: scale(1.1);
    }

    &.bookmarked {
        color: var(--accentColour);

        &:hover {
            transform: scale(1.1);
        }
    }

    svg {
        pointer-events: none;
    }
}
</style>
